export default __webpack_public_path__ + "static/media/assign_practice.601c2fd3.svg";